import { SvgIcon } from "@mui/material";
import React from "react";

const ArrowBackIcon = ({ variant, color }: { variant?: string; color?: string }) => {
  let c = "#8F8F8F";
  if (color) c = color;
  if (variant && variant === "blue")
    return (
      <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M4.66667 7.86854L8 11.2019V7.86854H4.66667Z" fill="#1062D0" />
        <path d="M8 4.5352L4.66667 7.86854H8V4.5352Z" fill="#1062D0" />
        <path
          d="M4.66667 7.86854L8 11.2019V7.86854M4.66667 7.86854L8 4.5352V7.86854M4.66667 7.86854H8M13 14.5352H13.8333C14.7174 14.5352 15.5652 14.184 16.1904 13.5589C16.8155 12.9338 17.1667 12.0859 17.1667 11.2019C17.1667 10.3178 16.8155 9.46997 16.1904 8.84485C15.5652 8.21972 14.7174 7.86854 13.8333 7.86854H8"
          stroke="#1062D0"
          strokeWidth="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    );
  return (
    <svg width="15" height="13" viewBox="0 0 15 13" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1.16699 4.50033H10.3337C11.2177 4.50033 12.0656 4.85151 12.6907 5.47664C13.3158 6.10176 13.667 6.9496 13.667 7.83366C13.667 8.71771 13.3158 9.56556 12.6907 10.1907C12.0656 10.8158 11.2177 11.167 10.3337 11.167H9.50033M4.50033 7.83366L1.16699 4.50033L4.50033 1.16699V7.83366Z"
        stroke={c}
        strokeWidth="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default ArrowBackIcon;
